module.exports = __webpack_public_path__ + "img/ИФ-1(А)-041.449a0868.png";